import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import { styles } from "./Rule.styles";
import { withStyles, WithStyles } from "@material-ui/core";

interface IRuleProps extends WithStyles<typeof styles> {
    text: string;
    valid: boolean;
}

const RulePure: React.FunctionComponent<IRuleProps> = ({ text, valid, classes }) => {
    return (
        <li className={classes.listItem}>
            {valid ? <CheckIcon className={classes.validIcon} /> : <CloseIcon className={classes.invalidIcon} />}
            <span>{text}</span>
        </li>
    );
};

export const Rule = withStyles(styles)(RulePure);
